import React from "react";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { CaptureProvider } from "../../../../contexts/capture";
import { useGroupedAsset } from "../../../../contexts/grouped-asset";
import FormPageGroupedAsset from "./FormPageGroupedAsset";

export const fetchGroupedAssetValues = asset => {
  if (!asset?.id) return {};

  return {
    manufacturer: asset.manufacturer || "",
    barcode: asset.barcode || "",
    description: asset.description || "",
    descriptionComments: asset.descriptionComments || "",
    color: asset.color || "",
    model: asset.model || "",
    skuNumber: asset.skuNumber || "",
    serializedGroupedAsset: asset.serializedGroupedAsset || false,
    dimensions: asset.dimensions,
  };
};

export default function GroupedAssetDetailsModal({ disabled, entity: item, onClose, projectId, refetch }) {
  const { groupedAsset, loading: loadingAsset } = useGroupedAsset();
  const entity = groupedAsset?.id ? groupedAsset : item;

  return (
    <CaptureProvider>
      <Formik
        key={entity?.id}
        enableReinitialize
        initialValues={fetchGroupedAssetValues(entity)}
        onSubmit={() => {}}
      >
        <form
          id="assetForm"
          className="d-flex flex-column flex-grow-1 justify-content-between justify-content-md-start"
          style={{ position: "relative" }}
        >
          <Dialog open fullWidth maxWidth="md" onClose={onClose}>
            <DialogTitle
              sx={{ background: "#f4f6f8", display: "flex", justifyContent: "space-between" }}
            >
              <Box width="48px" />
              <Typography fontSize={24} fontWeight={500} color="textPrimary">
                Grouped Item Details
              </Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <FormPageGroupedAsset
              disabled={disabled}
              type="scrubber"
              projectId={projectId}
              currentAsset={entity}
              onCloseModal={onClose}
              refetch={refetch}
            />
          </Dialog>
        </form>
      </Formik>
    </CaptureProvider>
  );
}

